import type { WordCollection } from "../collection.types";

export const summerSolsticeCollection: WordCollection = {
  id: "summer-solstice",
  title: "Summer Solstice (Litha)",
  icon: "white-balance-sunny",
  isWordlistViewable: true,
  startDate: new Date(new Date().getFullYear(), 5, 18), // June 18th
  endDate: new Date(new Date().getFullYear(), 5, 23), // June 23rd
  words: [
    "alive",
    "brilliant",
    "burn",
    "ceremony",
    "circle",
    "consume",
    "dance",
    "energy",
    "flame",
    "glow",
    "golden",
    "heat",
    "herb",
    "maximum",
    "mighty",
    "mint",
    "oak",
    "power",
    "prayer",
    "spark",
    "spell",
    "stone",
    "strong",
    "transform",
    "vibrant",
    "wealth",
  ],
};
